<div class="betslip-taxation-info__row betslip-stake-limits-overlay-info-header">
    <div class="betslip-taxation-info_text">{{ messages.common.MonthlyStakeHeader }}</div>
</div>
<div class="betslip-taxation-info__row betslip-stake-limits-overlay-info-message">
    <div class="betslip-taxation-info_text">{{ messages.common.MonthlyStakeSubHeader }}</div>
</div>
<div class="betslip-taxation-info__row betslip-stake-limits-overlay-info-message">
    <div class="betslip-taxation-info_text betslip-stake-limits-link-text" [innerHtml]="messages.common.MonthlyStakeInfoUrl | msTrust: 'html'"></div>
</div>
<div class="betslip-taxation-info__row betslip-stake-limits-overlay-info-help">
    <div class="betslip-taxation-info_text betslip-stake-limits-link-text" [innerHtml]="helpTextWithUrl | msTrust: 'html'"></div>
</div>
<div class="betslip-taxation-info_ok-text betslip-stake-limits-info-ok-text" (click)="okClick()">
    {{ messages.common.ConfirmStakeLimitMessage }}
</div>
